import React, { useState, useMemo } from "react";
import { useSearchParams, Routes, Route, useParams } from 'react-router-dom';
import { useQuery } from "@apollo/client";
// import { LEGAL_ADVISOR_OVERVIEW } from "../../../Queries/Pe"

const AdvisorOverview = ({ profileHighlights, isLoading }) => {
  // console.log("overview2", LEGAL_ADVISOR_OVERVIEW)
  // const [overview, setOverview] = useState({});
  // const [searchParams] = useSearchParams();

  // const { companyId } = useParams();
  //   let advisorProfileId = parseInt(companyId)
  // let advisorIdPE = parseInt(companyId)
  // let advisorType = "L";
  // const handleFetchOverviewRequestCallback = (response, requestSuccess) => {
  //   try {
  //     setOverview(response?.advisor??{});
  //   } catch (e) {
  //     console.log('Error', e)
  //   }
  // };

  // const { data, loading, error } = useQuery(LEGAL_ADVISOR_OVERVIEW, {
  //   variables: { AdvisorType: advisorType, CIAId: advisorIdPE },
  //   onCompleted: (response) => handleFetchOverviewRequestCallback(response, true),
  //   onError: (response) => handleFetchOverviewRequestCallback(response),
  //   refetch: LEGAL_ADVISOR_OVERVIEW

  // })
  // console.log("profile1", LEGAL_ADVISOR_OVERVIEW)

  // const OverviewData = useMemo(() => overview, [overview]);
  // console.log("overviewdata", OverviewData)
  return (
    <div>
      <div className=" px-4 bg-[#EDEDED]">
        <div className="">
          <div
            className="lg:mt-4 lg:bg-white  rounded-[6px] shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]"
            x-show="tab === 1"
          >
            <div className="w-full lg:grid lg:grid-cols-6  ">
              <div className=" mt-3 lg:mt-0 sm:rounded-lg lg:col-span-6 lg:border-r bg-white shadow-[0_2px_6px_0_rgba(0,0,0,0.08)] ">
                <div className="px-5 py-4 ">
                  <p className=" text-[14pt] leading-[19pt]  lg:text-[17px] text-[#333333] font-semibold  lg:leading-[22px]">
                    Profile
                  </p>
                  {Object.keys(profileHighlights)?.length <= 0 ?
                    <table className="h-[10rem] w-full bg-[#FFFFFF] ">
                      <center><div role="status" className="bg-white  h-[16rem]">
                        <svg className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                      </div></center>
                    </table>
                    :
                    <div className="overflow-x-auto scrollbar mt-1 ">
                      <table className=" w-full font-sans_book_body ">
                        <tr className=" table-row align-top">
                          <td className="lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt]  text-[#333333]   whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Contact Person
                            </p>


                          </td>
                          <td className=" px-12 lg:px-5 lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] font-sans_book_body whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Designation
                            </p>


                          </td>
                          <td className="  lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Email
                            </p>


                          </td>
                          <td className="px-5 lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Telephone
                            </p>


                          </td>
                        </tr>
                        <tr className="border-b-[#E5E5E5] border-b space-x-6 font-sans_book_body table-row align-top">
                          <td className="lg:leading-[21px]">

                            <p className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">
                              {profileHighlights?.contactperson ? profileHighlights?.contactperson : "--"}
                            </p>

                          </td>
                          <td className=" px-12 lg:px-5 lg:leading-[21px]">

                            <p className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">
                              {profileHighlights?.designation ? profileHighlights?.designation : "--"}
                            </p>

                          </td>
                          <td className=" lg:leading-[21px]">

                            <p className=" text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">
                              {profileHighlights?.email ? profileHighlights?.email : "--"}
                            </p>

                          </td>
                          <td className="px-5 lg:leading-[21px]">

                            <p className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">
                              {profileHighlights?.telephone ? profileHighlights?.telephone : "--"}
                            </p>

                          </td>
                        </tr>
                        <tr className="table-row align-top mb-1">
                          <td className=" lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Website
                            </p>


                          </td>
                          <td className=" px-12 lg:px-5 lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Address
                            </p>

                          </td>
                          <td className=" lg:leading-[21px]">
                            <p
                              className=" lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              City
                            </p>


                          </td>
                          <td className=" px-5 lg:leading-[21px]">
                            <p
                              className="lg:text-[13px]  text-[11pt]  mb-0  leading-[18pt] text-[#333333] whitespace-nowrap cursor-auto"
                              readOnly
                            >
                              Country
                            </p>

                          </td>
                        </tr>
                        <tr className="space-x-6 font-sans_book_body table-row align-top">
                          <td className=" lg:leading-[21px]">

                            <a className="text-[11pt]  cursor-pointer leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap  font-semibold "
                              href={profileHighlights?.website}
                              target='_blank'
                            >
                              {profileHighlights?.website ? profileHighlights?.website : "--"}
                            </a>

                          </td>
                          <td className=" px-12 lg:px-5 lg:leading-[21px]">

                            <p className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">
                              {profileHighlights?.address ? profileHighlights?.address : "--"}
                            </p>

                          </td>
                          <td className=" lg:leading-[21px]">

                            <p className=" text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">
                              {profileHighlights?.city ? profileHighlights?.city : "--"}
                            </p>

                          </td>
                          <td className=" pl-5 lg:leading-[21px]">
                          <p className=" text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold ">

                          {profileHighlights?.country  ? profileHighlights?.country   : "--"}
                          </p>

                          </td>
                        </tr>
                      </table>
                    </div>
                  }
                </div>
              </div>
              {/* <!--first half end--> */}

              {/* <!--end--> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvisorOverview;